/**
 * Application Constants
 */

// Scan Types
export const SCAN_TYPES = [
  { value: 'FLAIR', label: 'FLAIR' },
  { value: 'T1', label: 'T1-weighted' },
  { value: 'T2', label: 'T2-weighted' },
  { value: 'DWI', label: 'Diffusion-weighted (DWI)' },
  { value: 'SWI', label: 'Susceptibility-weighted (SWI)' },
  { value: 'OTHER', label: 'Other' },
];

// File Upload Constraints
export const FILE_UPLOAD = {
  MAX_SIZE: 1024 * 1024 * 1024, // 1GB
  ALLOWED_TYPES: [
    'application/dicom',
    'application/dicom+json',
    'application/octet-stream', // Common for .nii and .dcm files
    'image/dicom-rle',
  ],
  ALLOWED_EXTENSIONS: ['.dcm', '.nii', '.nii.gz'],
  DISPLAY_FORMATS: 'DICOM (.dcm) and NIfTI (.nii, .nii.gz)',
};

// Scan Status
export const SCAN_STATUS = {
  UPLOADED: 'uploaded',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

// Disease Status
export const DISEASE_STATUS = {
  STABLE: 'stable',
  PROGRESSING: 'progressing',
  IMPROVING: 'improving',
};

// Risk Levels
export const RISK_LEVELS = {
  LOW: 'low',
  MODERATE: 'moderate',
  HIGH: 'high',
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UPLOAD_FAILED: 'Failed to upload scan. Please try again.',
  INVALID_FILE: 'Invalid file type. Please upload DICOM (.dcm) or NIfTI (.nii, .nii.gz) files only.',
  FILE_TOO_LARGE: 'File size exceeds the maximum limit of 1GB.',
  UNAUTHORIZED: 'You are not authorized. Please login again.',
  SERVER_ERROR: 'Server error. Please try again later.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  UPLOAD_SUCCESS: 'Scan uploaded successfully!',
  ANALYSIS_TRIGGERED: 'Analysis triggered successfully!',
  LOGIN_SUCCESS: 'Login successful!',
  LOGOUT_SUCCESS: 'Logout successful!',
};

export default {
  SCAN_TYPES,
  FILE_UPLOAD,
  SCAN_STATUS,
  DISEASE_STATUS,
  RISK_LEVELS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
};

